/**
 * navigationCallbacks.js
 * Global registry for navigation callbacks that cannot be passed as params.
 * Used to pass onSave/onSuccess functions between screens.
 */
const _callbacks = new Map();

export const registerCallback = (key, fn) => {
  _callbacks.set(key, fn);
};

export const getCallback = (key) => {
  return _callbacks.get(key) || null;
};

export const clearCallback = (key) => {
  _callbacks.delete(key);
};
